module.exports = __webpack_public_path__ + "static/redpoint-team-image-1-40ed955fb67a2e71af37136741e41194.png";